import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Step from '../parts/Step';
import {setLanguageIndex, checkboxLog, selectLog} from '../../utils/helpers';
import {Maybe} from '../../utils/logging';

class WtContent extends Component {

    render() {
        let name;
        const value = '';
        return this.props.list.map((el, index, arr) => {
            let details = [];
            if (index === arr.length - 1) {
                name = 'downloadAndContact.title';
            } else {
                name = `${this.props.field}.${this._handleStepName(index, arr)}.menu.title`;
                details = this._updateContent(el, index, arr);
            }
            return (
                <Step
                    key={index}
                    name={this.props.translate(name)}
                    value={value}
                    details={details}
                    currentStep={this.props.currentStep}
                    stepNo={index + 1} />

            );
        });
    }

    /**
     * _updataContent
     *
     * @param{string} stepName
     * @param{number} index
     * @param{Array} arr
     * @returns {Array} details
     *
     */
    _updateContent(stepName, index, arr) {
        // Define details
        const details = [];

        // Switch statement to push element to details for each step
        switch(stepName) {

            case 'One':
                Maybe.of(this.props.wt.W_BREITE && this.props.wt.W_TIEFE)
                    .map(() => {
                        return this.props.wt.W_BREITE.CurrentValue && this.props.wt.WT_TIEFE.CurrentValue
                    })
                    .map(() => {
                        if (parseInt(this.props.wt.VAR_ABM.CurrentValue) === 0) {
                            details.push(`${this.props.translate(`${this.props.field}.${this._handleStepName(index, arr)}.menu.body.1`)} ${this.props.wt.W_BREITE.CurrentValue} cm x ${this.props.wt.WT_TIEFE.CurrentValue} cm`);
                        }
                    });
                Maybe.of(this.props.wt.VAR_ABM)
                    .map((var_abm) => {
                        // details.push(`${this.props.translate(`${this.props.field}.${this.handleStepName(index, arr)}.menu.body.2`)} ${this.props.wt.LAENGE.CurrentValue} x ${this.props.wt.BREITE.CurrentValue}`);
                        details.push(`${this.props.translate(`${this.props.field}.${this._handleStepName(index, arr)}.menu.body.2`)} ${this._calculateSize('breite')} cm x ${this._calculateSize('tiefe')} cm`);
                    });

                break;

            case 'Two':
                // Define wt_alaz_checkbox
                let wt_alaz_checkbox = '';
                // Define wt_als_checkbox
                let wt_als_checkbox = '';
                // Set spv
                let sspv = '';

                // Set WT_ALP2
                const WT_ALP2 = (wt_alaz, wt_alp1) => {
                    return Maybe.of(selectLog(this.props, 'wt', 'WT_ALP2', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                    .map((value) => {
                        details.push(`${wt_alaz_checkbox}: ${wt_alaz} ${wt_alp1} ${value}`)
                        return true;
                    })
                }
                // Set WT_ALP1
                const WT_ALP1 = (wt_alaz) => {
                    return Maybe.of(selectLog(this.props, 'wt', 'WT_ALP1',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
                    .map((value) => {
                        return value;
                    })
                    .map((wt_alp1) => {
                        return WT_ALP2(wt_alaz, wt_alp1)
                        .orElseFun(() => {
                            details.push(`${wt_alaz_checkbox}: ${wt_alaz} ${wt_alp1}`);
                            return true;
                        })
                    })
                }

                // Set WT_ALAZ
                const WT_ALAZ = (() => {
                    return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_WT_ALAZ_checkbox', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        wt_alaz_checkbox = value;
                        return value;
                    })
                    .map(() => {
                        return Maybe.of(selectLog(this.props, 'wt', 'WT_ALAZ',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
                        .map((value) => {
                            return value;
                        })
                        .map((wt_alaz) => {
                            return WT_ALP1(wt_alaz)
                            .orElseFun(() => {
                                details.push(`${wt_alaz_checkbox}: ${wt_alaz}`);
                                return true;
                            })
                        })
                        .join()
                    })
                })();

                // Set WT_ALS
                const WT_ALS = (() => {
                    return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_WT_ALS_checkbox', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        wt_als_checkbox = value;
                        return value;
                    })
                    .map(() => {
                        return Maybe.of(selectLog(this.props, 'wt', 'WT_ALS', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                        .map((value) => {
                            details.push(`${wt_als_checkbox} ${value}`);
                            return true;
                        })
                        .join()
                    })
                })()
                .orElseFun(() => {
                    details.push(wt_als_checkbox);
                })

                // Set SSP
                const SSP = (() => {
                    return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_SSPV_checkbox', this._handleStepName(index, arr))._value)
                        .map((value) => {
                            sspv = value;
                            return value;
                        })
                        .map(() => {
                            return Maybe.of(selectLog(this.props, 'wt', 'SSP', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                                .map((value) => {
                                    if(this.props.wt.SSP.CurrentValue !== '00') {
                                        details.push(`${sspv} ${value}`);
                                    }
                                    return true;
                                })
                                .join()
                        })
                })();

                // Set ST
                Maybe.of(checkboxLog(this.props, 'wt', 'ST', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        details.push(value);
                    });

                // Set HTH
                Maybe.of(checkboxLog(this.props, 'wt', 'HTH', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        details.push(value);
                    });

                break;

            case 'Three':
                // Set KTSV
                let ktsv = '';

                // Set KTS
                const KTS = (() => {
                    return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_KTSV_checkbox', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        ktsv = value;
                        return value;
                    })
                    .map(() => {
                        return Maybe.of(selectLog(this.props, 'wt', 'KTS', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                        .map((value) => {
                            if(this.props.wt.KTS.CurrentValue !== '00') {
                                details.push(`${ktsv} ${value}`);
                            }
                            return true;
                        })
                        .join()
                    })
                })();

                // Set UL
                Maybe.of(checkboxLog(this.props, 'wt', 'UL_inverter', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        details.push(value);
                    });

                break;

            case 'Four':
                // Set FA
                Maybe.of(selectLog(this.props, 'wt', 'FA',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
                    .map((value) => {
                        details.push(value);
                        return true;
                    });
                // Set OV
                Maybe.of(checkboxLog(this.props, 'wt', 'OV', this._handleStepName(index, arr))._value)
                    .map((value) => {
                        details.push(value);
                        return true;
                    });

                break;

            default:
                return details;

}
        return details;
    }


    /**
     * _handleStepName
     *
     * @param {integer} number
     * @param {string} names
     * @returns {string} full name
     *
     */
    _handleStepName(number, names) {
        const step = 'step';
        return `${step}${names[number]}`;
    }

    /**
     * _calculateSize for step one
     *
     */
    _calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return parseFloat(field.CurrentValue);
            })._value || 0;
        }
        if (type === 'tiefe') {
            if(parseInt(this.props.wt.VAR_ABM.CurrentValue) === 1) {
                return getValue(this.props.wt.WT_TIEFE);
            } else {
                const w_tiefe = getValue(this.props.wt.WT_TIEFE);
                const SO45 = getValue(this.props.wt.SO45);
                const SO81 = getValue(this.props.wt.SO81);
                return w_tiefe + SO45 + SO81;
            }
        }
        if (type === 'breite') {
            if (parseInt(this.props.wt.VAR_ABM.CurrentValue) === 1) {
                return getValue(this.props.wt.W_BREITE);
            } else {
                const w_breite = getValue(this.props.wt.W_BREITE);
                const SO23 = getValue(this.props.wt.SO23);
                const SO67 = getValue(this.props.wt.SO67);
                return w_breite + SO23 + SO67;
            }
        }
    }

}

/**
* Prop types
* @type {{tempDetails: *}}
*/
WtContent.propTypes = {
    wt:              PropTypes.object.isRequired,
    translate:       PropTypes.func.isRequired,
    currentLanguage: PropTypes.string,
    list:            PropTypes.array,
    field:           PropTypes.string,
    currentStep:     PropTypes.number,
};


function mapStateToProps({wt, locale}) {
    return {
        translate:       getTranslate(locale),
        currentLanguage: getActiveLanguage(locale).code,
        wt,
    }
}

export default connect(mapStateToProps)(WtContent);



// WEBPACK FOOTER //
// ./src/components/sidebar-menu/WtContent.js